export default __webpack_public_path__ + "static/BG-bd8245c38046f800b63325dc87c3be17.png";